import { render, staticRenderFns } from "./PageAvisoLegalEsp.vue?vue&type=template&id=737064eb&"
import script from "./PageAvisoLegalEsp.vue?vue&type=script&lang=js&"
export * from "./PageAvisoLegalEsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports